import React from 'react';
import PropTypes from 'prop-types';

/**
 * TestTubeLabel:
 *  - Render the label of TestTube
 */
export function TestTubeLabel({label}) {
  return <p className='option-label'>{label}</p>;
}

TestTubeLabel.propTypes = {
  /**
   * Label for the option to be displayed on top of TestTube
   */
  label: PropTypes.string,
};
